/**
 * Manage nav catalog. `path` is relative to router basename.
 * All admin modules are native in the public app at /manage.
 */
export const MANAGE_MODULES = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    path: '/manage',
    exact: true,
    native: true,
  },
  {
    key: 'users',
    label: 'Users',
    path: '/manage/users',
    native: true,
  },
  {
    key: 'donations',
    label: 'Donations',
    path: '/manage/donations',
    native: true,
  },
  {
    key: 'donation_type',
    label: 'Donation Type',
    path: '/manage/donation-type',
    native: true,
  },
  {
    key: 'gallary',
    label: 'Gallary',
    path: '/manage/gallery',
    native: true,
  },
  {
    key: 'hero_banner',
    label: 'Hero Banner',
    path: '/manage/hero-banner',
    native: true,
  },
  {
    key: 'pages',
    label: 'Pages',
    path: '/manage/pages',
    native: true,
  },
  {
    key: 'menus',
    label: 'Menus',
    path: '/manage/menus',
    native: true,
  },
  {
    key: 'settings',
    label: 'Settings',
    path: '/manage/settings',
    native: true,
  },
  {
    key: 'user_roles',
    label: 'User Roles',
    path: '/manage/roles',
    native: true,
  },
  {
    key: 'user_reports',
    label: 'User Reports',
    path: '/manage/user-reports',
    native: true,
  },
  {
    key: 'donation_reports',
    label: 'Donation Reports',
    path: '/manage/donation-reports',
    native: true,
  },
]

export function moduleByKey(key) {
  return MANAGE_MODULES.find((m) => m.key === key)
}
